module.exports = __webpack_public_path__ + "f1fe9048d24785a6cf7bb61f6cd8802a.svg";